

export const getAppOptions = async () => {
    
    //let rootURL = 'http://localhost/devwp/'; 
    //if the path doesnt work in dev environment add the full path
    const response = await fetch(
        '/wp-json/calc_options/v1/calc_options/',{
            'Content-type': 'application/json',
            'Accept': 'application/json'
        });
    const data = await response.json();

    return data;
}

